'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Retrieves the job settings based on if there are overrides or not
 * @param model the job range model
 * @param job the model job
 * @returns {*} the current job settings based on if there are overrides or not
 */
var getJobSettings = exports.getJobSettings = function getJobSettings(model, job) {
  // TODO: This should be simplified once the job and model have consistent naming convention
  // currently, model is camelCase and job is underscore.

  var settings = void 0;
  if (doesJobContainSpecificRangeDetails(job)) {
    settings = {
      rangeType: job ? job.range_type : null,
      proposedRangeSetting: job ? job.proposed_range_setting : null,
      targetRangeSpread: job ? job.target_range_spread : null,
      midpointAdjustment: job ? job.midpoint_adjustment : null,
      proposedMidpoint: job ? job.proposed_midpoint : null,
      buildMinMaxBy: job ? job.build_min_max_by : null,
      minPercentageOfMid: job ? job.min_percentage_of_mid : null,
      maxPercentageOfMid: job ? job.max_percentage_of_mid : null,
      minPercentageMarketElement: job ? job.min_percentage_market_element : null,
      maxPercentageMarketElement: job ? job.max_percentage_market_element : null,
      proposedMinimum: job ? job.proposed_minimum : null,
      proposedMaximum: job ? job.proposed_maximum : null,
      payType: model ? model.payType : null,
      roundTo: model ? model.roundTo : null
    };
  } else {
    settings = {
      rangeType: model ? model.rangeType : null,
      proposedRangeSetting: model ? model.proposedRangeSetting : null,
      targetRangeSpread: model ? model.targetRangeSpread : null,
      midpointAdjustment: model ? model.midpointAdjustment : null,
      buildMinMaxBy: model ? model.buildMinMaxBy : null,
      minPercentageOfMid: model ? model.minPercentageOfMid : null,
      maxPercentageOfMid: model ? model.maxPercentageOfMid : null,
      minPercentageMarketElement: model ? model.minPercentageMarketElement : null,
      maxPercentageMarketElement: model ? model.maxPercentageMarketElement : null,
      proposedMidpoint: job ? job.proposed_midpoint : null,
      proposedMinimum: job ? job.proposed_minimum : null,
      proposedMaximum: job ? job.proposed_maximum : null,
      payType: model ? model.payType : null,
      roundTo: model ? model.roundTo : null
    };
  }
  return settings;
};

/**
 * Determines if a job contains manual job range settings specific to the job.
 * @param job the job
 * @returns {boolean} <b>true</b> if the job contains range details. <b>false</b> if not.
 */
var doesJobContainSpecificRangeDetails = exports.doesJobContainSpecificRangeDetails = function doesJobContainSpecificRangeDetails(job) {
  if (!job) return;
  return job.target_range_spread !== null && job.target_range_spread !== undefined || job.midpoint_adjustment !== null && job.midpoint_adjustment !== undefined || job.range_type !== null && job.range_type !== undefined || job.proposed_range_setting !== null && job.proposed_range_setting !== undefined || job.build_min_max_by !== null && job.build_min_max_by !== undefined || job.min_percentage_of_mid !== null && job.min_percentage_of_mid !== undefined || job.max_percentage_of_mid !== null && job.max_percentage_of_mid !== undefined || job.min_percentage_market_element !== null && job.min_percentage_market_element !== undefined || job.max_percentage_market_element !== null && job.max_percentage_market_element !== undefined || job.range_type === 'manual';
};